// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.call-details[data-v-3493807a] {
  position: relative;
  margin-left: -20px;
  margin-right: -20px;
  width: 350px;
}
.call-details .call-details-header[data-v-3493807a] {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 15px;
  margin-top: -30px;
}
.call-details .call-details-header .icon-block[data-v-3493807a] {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 70px;
  height: 70px;
  font-size: 28px;
}
.call-details .call-details-header span.fio[data-v-3493807a] {
  font-size: 18px;
  margin-bottom: 5px;
}
.call-details .call-details-header span.type[data-v-3493807a] {
  font-size: 15px;
  color: #8D8D8D;
}
.call-details .call-details-buttons[data-v-3493807a] {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  height: 90px;
  border-bottom: 1px solid var(--list-item-bordercolor);
  padding-bottom: 15px;
}
.call-details .call-details-buttons .call-details-button[data-v-3493807a] {
  width: 85px;
  text-align: center;
  cursor: pointer;
}
.call-details .call-details-buttons .call-details-button div[data-v-3493807a] {
  height: 48px;
  width: 48px;
  border-radius: 50%;
  color: var(--base-blue-color);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
}
.call-details .call-details-buttons .call-details-button i[data-v-3493807a] {
  font-size: 16px;
}
.call-details .call-details-buttons .call-details-button span[data-v-3493807a] {
  color: var(--base-blue-color);
  font-size: 11px;
  display: inline-block;
  margin-top: 4px;
}
.call-details .call-details-body[data-v-3493807a] {
  max-height: calc(var(--vh) * 70 - 271px);
  overflow-y: auto;
  padding: 6px 15px;
  font-size: 12px;
}
.call-details .call-details-body .call-details-body-title[data-v-3493807a] {
  font-size: 16px;
  font-weight: bold;
  padding-top: 7px;
}
.call-details .call-details-body .call[data-v-3493807a] {
  margin-bottom: 4px;
}
.call-details .call-details-body .call .call-details-datagroup[data-v-3493807a] {
  font-weight: bold;
  margin: 10px 0px;
}
.call-details .call-details-body .call .call-item[data-v-3493807a] {
  display: flex;
}
.call-details .call-details-body .call .call-item .date[data-v-3493807a] {
  width: 133px;
  font-size: 13px;
  color: var(--placeholder-color);
}
.call-details .call-details-body .call .call-item .red-font[data-v-3493807a] {
  color: var(--elem-red-color);
}
.call-details .call-details-body .call .call-item .time[data-v-3493807a] {
  flex-grow: 1;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/calls/CallDetails.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;EACZ,qDAAqD;EACrD,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".call-details[data-v-3493807a] {\n  position: relative;\n  margin-left: -20px;\n  margin-right: -20px;\n  width: 350px;\n}\n.call-details .call-details-header[data-v-3493807a] {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: 15px;\n  margin-top: -30px;\n}\n.call-details .call-details-header .icon-block[data-v-3493807a] {\n  margin-top: 15px;\n  margin-bottom: 15px;\n  width: 70px;\n  height: 70px;\n  font-size: 28px;\n}\n.call-details .call-details-header span.fio[data-v-3493807a] {\n  font-size: 18px;\n  margin-bottom: 5px;\n}\n.call-details .call-details-header span.type[data-v-3493807a] {\n  font-size: 15px;\n  color: #8D8D8D;\n}\n.call-details .call-details-buttons[data-v-3493807a] {\n  display: flex;\n  justify-content: space-around;\n  align-items: flex-end;\n  height: 90px;\n  border-bottom: 1px solid var(--list-item-bordercolor);\n  padding-bottom: 15px;\n}\n.call-details .call-details-buttons .call-details-button[data-v-3493807a] {\n  width: 85px;\n  text-align: center;\n  cursor: pointer;\n}\n.call-details .call-details-buttons .call-details-button div[data-v-3493807a] {\n  height: 48px;\n  width: 48px;\n  border-radius: 50%;\n  color: var(--base-blue-color);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n}\n.call-details .call-details-buttons .call-details-button i[data-v-3493807a] {\n  font-size: 16px;\n}\n.call-details .call-details-buttons .call-details-button span[data-v-3493807a] {\n  color: var(--base-blue-color);\n  font-size: 11px;\n  display: inline-block;\n  margin-top: 4px;\n}\n.call-details .call-details-body[data-v-3493807a] {\n  max-height: calc(var(--vh) * 70 - 271px);\n  overflow-y: auto;\n  padding: 6px 15px;\n  font-size: 12px;\n}\n.call-details .call-details-body .call-details-body-title[data-v-3493807a] {\n  font-size: 16px;\n  font-weight: bold;\n  padding-top: 7px;\n}\n.call-details .call-details-body .call[data-v-3493807a] {\n  margin-bottom: 4px;\n}\n.call-details .call-details-body .call .call-details-datagroup[data-v-3493807a] {\n  font-weight: bold;\n  margin: 10px 0px;\n}\n.call-details .call-details-body .call .call-item[data-v-3493807a] {\n  display: flex;\n}\n.call-details .call-details-body .call .call-item .date[data-v-3493807a] {\n  width: 133px;\n  font-size: 13px;\n  color: var(--placeholder-color);\n}\n.call-details .call-details-body .call .call-item .red-font[data-v-3493807a] {\n  color: var(--elem-red-color);\n}\n.call-details .call-details-body .call .call-item .time[data-v-3493807a] {\n  flex-grow: 1;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
